import { render, staticRenderFns } from "./revert.vue?vue&type=template&id=35ad299d&functional=true"
import script from "./revert.vue?vue&type=script&lang=js"
export * from "./revert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports